import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { UserService } from '@classifieds-sell/datalayer';
import {
    exhaustMap,
    map,
    mergeMap,
    withLatestFrom,
    catchError
} from 'rxjs/operators';
import { of } from 'rxjs';
import * as UserActions from './user.actions';
import * as UserFeature from './user.reducer';
import * as UserSelectors from './user.selectors';

@Injectable()
export class UserEffects {
    loadUserDetails$ = createEffect(() =>
        this.actions$.pipe(
            ofType(UserActions.getUserDetails),
            withLatestFrom(
                this.store.select(UserSelectors.getUserDetails),
                (_action, state) => state
            ),
            mergeMap((state: UserFeature.UserState) => {
                if (state && state.memberSummary?.memberId > 0) {
                    return [UserActions.noOpAction()];
                }

                return this.userService.getUserDetails().pipe(
                    map((ud) =>
                        UserActions.getUserDetailsSuccess({
                            userDetails: ud
                        })
                    )
                );
            })
        )
    );

    reloadUserDetails$ = createEffect(() =>
        this.actions$.pipe(
            ofType(UserActions.reloadUserDetails),
            mergeMap(() => {
                return this.userService.getUserDetails().pipe(
                    map((ud) => UserActions.getUserDetailsSuccess({
                        userDetails: ud
                      })
                    )
                );
            })
        )
    );

    updateUserDetails$ = createEffect(() =>
        this.actions$.pipe(
            ofType(UserActions.updateUserDetails),
            exhaustMap((action) => {
                return this.userService
                    .updateUserDetails(action.userUpdateDetailsRequest)
                    .pipe(
                        map((response) => UserActions.updateUserDetailsSuccess({ userUpdated: response} )),
                        catchError((error: unknown) =>
                            of(UserActions.updateUserDetailsFailure({ error }))
                        )
                    );
            })
        )
    );

    constructor(
        private actions$: Actions,
        private store: Store<UserFeature.UserPartialState>,
        private userService: UserService
    ) {}
}
